import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/questionsTypes.action'
import questionTypes from 'api/administration/questionTypes/List'

async function getList() {
  return await questionTypes()
}

function* questionsTypesListEffectSaga() {
  try {
    const data = yield call(getList)
    yield put(fromActions.Actions.questionTypesListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* questionTypesListWatcherSaga() {
  yield takeLatest(fromActions.GET_QUESTION_TYPES_LIST, questionsTypesListEffectSaga)
}
